
export const supportedLocales = new Set([
  'ar-AE',
  'ar-BH',
  'ar-EG',
  'ar-JO',
  'ar-KW',
  'ar-LB',
  'ar-MA',
  'ar-OM',
  'ar-QA',
  'ar-SA',
  'ar',
  'az-AZ',
  'az',
  'bg-BG',
  'bg',
  'ca-ES',
  'ca',
  'cs-CZ',
  'cs',
  'da-DK',
  'da',
  'de-AT',
  'de-BE',
  'de-CH',
  'de-DE',
  'de',
  'el-CY',
  'el-GR',
  'el',
  'en-AE',
  'en-BH',
  'en-BN',
  'en-CA',
  'en-EG',
  'en-ES',
  'en-KW',
  'en-LB',
  'en-LK',
  'en-MT',
  'en-MU',
  'en-MY',
  'en-NZ',
  'en-OM',
  'en-PH',
  'en-PK',
  'en-QA',
  'en-SA',
  'en-SG',
  'en-UK',
  'en-US',
  'en-ZA',
  'en',
  'es-CL',
  'es-ES',
  'es-VE',
  'es',
  'et-EE',
  'et',
  'fi-FI',
  'fi',
  'fr-BE',
  'fr-CH',
  'fr-JO',
  'fr-LB',
  'fr-MA',
  'fr-MU',
  'fr',
  'hr-HR',
  'hr',
  'hu-HU',
  'hu',
  'id-ID',
  'id',
  'it-CH',
  'it-IT',
  'it',
  'ka-GE',
  'ka',
  'ko-KR',
  'ko',
  'lt-LT',
  'lt',
  'lv-LV',
  'lv',
  'ms-BN',
  'ms-MY',
  'ms',
  'nl-BE',
  'nl-NL',
  'nl',
  'pl-PL',
  'pl',
  'pt-PT',
  'pt',
  'ro-MD',
  'ro-RO',
  'ro',
  'ru-EE',
  'ru-LV',
  'ru',
  'sk-SK',
  'sk',
  'sl-SL',
  'sl',
  'sr-RS',
  'sr',
  'th-TH',
  'th',
  'tr-TR',
  'tr',
  'vi-VN',
  'vi',
  'xx-XX',
  'yy-XX',
  'yy-YY',
  'zh-HK',
  'zh',
  'zu-ZA',
  'zu'
]);
export const rollupLocales = new Map([
  [
    'ar-AE',
    [
      'global',
      'ar',
      'ar-AE'
    ]
  ],
  [
    'ar-BH',
    [
      'global',
      'ar',
      'ar-BH'
    ]
  ],
  [
    'ar-EG',
    [
      'global',
      'ar',
      'ar-EG'
    ]
  ],
  [
    'ar-JO',
    [
      'global',
      'ar',
      'ar-JO'
    ]
  ],
  [
    'ar-KW',
    [
      'global',
      'ar',
      'ar-KW'
    ]
  ],
  [
    'ar-LB',
    [
      'global',
      'ar',
      'ar-LB'
    ]
  ],
  [
    'ar-MA',
    [
      'global',
      'ar',
      'ar-MA'
    ]
  ],
  [
    'ar-OM',
    [
      'global',
      'ar',
      'ar-OM'
    ]
  ],
  [
    'ar-QA',
    [
      'global',
      'ar',
      'ar-QA'
    ]
  ],
  [
    'ar-SA',
    [
      'global',
      'ar',
      'ar-SA'
    ]
  ],
  [
    'ar',
    [
      'global',
      'ar'
    ]
  ],
  [
    'az-AZ',
    [
      'global',
      'az',
      'az-AZ'
    ]
  ],
  [
    'az',
    [
      'global',
      'az'
    ]
  ],
  [
    'bg-BG',
    [
      'global',
      'bg',
      'bg-BG'
    ]
  ],
  [
    'bg',
    [
      'global',
      'bg'
    ]
  ],
  [
    'ca-ES',
    [
      'global',
      'ca',
      'ca-ES'
    ]
  ],
  [
    'ca',
    [
      'global',
      'ca'
    ]
  ],
  [
    'cs-CZ',
    [
      'global',
      'cs',
      'cs-CZ'
    ]
  ],
  [
    'cs',
    [
      'global',
      'cs'
    ]
  ],
  [
    'da-DK',
    [
      'global',
      'da',
      'da-DK'
    ]
  ],
  [
    'da',
    [
      'global',
      'da'
    ]
  ],
  [
    'de-AT',
    [
      'global',
      'de',
      'de-AT'
    ]
  ],
  [
    'de-BE',
    [
      'global',
      'de',
      'de-BE'
    ]
  ],
  [
    'de-CH',
    [
      'global',
      'de',
      'de-CH'
    ]
  ],
  [
    'de-DE',
    [
      'global',
      'de',
      'de-DE'
    ]
  ],
  [
    'de',
    [
      'global',
      'de'
    ]
  ],
  [
    'el-CY',
    [
      'global',
      'el',
      'el-CY'
    ]
  ],
  [
    'el-GR',
    [
      'global',
      'el',
      'el-GR'
    ]
  ],
  [
    'el',
    [
      'global',
      'el'
    ]
  ],
  [
    'en-AE',
    [
      'global',
      'en',
      'en-AE'
    ]
  ],
  [
    'en-BH',
    [
      'global',
      'en',
      'en-BH'
    ]
  ],
  [
    'en-BN',
    [
      'global',
      'en',
      'en-BN'
    ]
  ],
  [
    'en-CA',
    [
      'global',
      'en',
      'en-CA'
    ]
  ],
  [
    'en-EG',
    [
      'global',
      'en',
      'en-EG'
    ]
  ],
  [
    'en-ES',
    [
      'global',
      'en',
      'en-ES'
    ]
  ],
  [
    'en-KW',
    [
      'global',
      'en',
      'en-KW'
    ]
  ],
  [
    'en-LB',
    [
      'global',
      'en',
      'en-LB'
    ]
  ],
  [
    'en-LK',
    [
      'global',
      'en',
      'en-LK'
    ]
  ],
  [
    'en-MT',
    [
      'global',
      'en',
      'en-MT'
    ]
  ],
  [
    'en-MU',
    [
      'global',
      'en',
      'en-MU'
    ]
  ],
  [
    'en-MY',
    [
      'global',
      'en',
      'en-MY'
    ]
  ],
  [
    'en-NZ',
    [
      'global',
      'en',
      'en-NZ'
    ]
  ],
  [
    'en-OM',
    [
      'global',
      'en',
      'en-OM'
    ]
  ],
  [
    'en-PH',
    [
      'global',
      'en',
      'en-PH'
    ]
  ],
  [
    'en-PK',
    [
      'global',
      'en',
      'en-PK'
    ]
  ],
  [
    'en-QA',
    [
      'global',
      'en',
      'en-QA'
    ]
  ],
  [
    'en-SA',
    [
      'global',
      'en',
      'en-SA'
    ]
  ],
  [
    'en-SG',
    [
      'global',
      'en',
      'en-SG'
    ]
  ],
  [
    'en-UK',
    [
      'global',
      'en',
      'en-UK'
    ]
  ],
  [
    'en-US',
    [
      'global',
      'en',
      'en-US'
    ]
  ],
  [
    'en-ZA',
    [
      'global',
      'en',
      'en-ZA'
    ]
  ],
  [
    'en',
    [
      'global',
      'en'
    ]
  ],
  [
    'es-CL',
    [
      'global',
      'es',
      'es-CL'
    ]
  ],
  [
    'es-ES',
    [
      'global',
      'es',
      'es-ES'
    ]
  ],
  [
    'es-VE',
    [
      'global',
      'es',
      'es-VE'
    ]
  ],
  [
    'es',
    [
      'global',
      'es'
    ]
  ],
  [
    'et-EE',
    [
      'global',
      'et',
      'et-EE'
    ]
  ],
  [
    'et',
    [
      'global',
      'et'
    ]
  ],
  [
    'fi-FI',
    [
      'global',
      'fi',
      'fi-FI'
    ]
  ],
  [
    'fi',
    [
      'global',
      'fi'
    ]
  ],
  [
    'fr-BE',
    [
      'global',
      'fr',
      'fr-BE'
    ]
  ],
  [
    'fr-CH',
    [
      'global',
      'fr',
      'fr-CH'
    ]
  ],
  [
    'fr-JO',
    [
      'global',
      'fr',
      'fr-JO'
    ]
  ],
  [
    'fr-LB',
    [
      'global',
      'fr',
      'fr-LB'
    ]
  ],
  [
    'fr-MA',
    [
      'global',
      'fr',
      'fr-MA'
    ]
  ],
  [
    'fr-MU',
    [
      'global',
      'fr',
      'fr-MU'
    ]
  ],
  [
    'fr',
    [
      'global',
      'fr'
    ]
  ],
  [
    'hr-HR',
    [
      'global',
      'hr',
      'hr-HR'
    ]
  ],
  [
    'hr',
    [
      'global',
      'hr'
    ]
  ],
  [
    'hu-HU',
    [
      'global',
      'hu',
      'hu-HU'
    ]
  ],
  [
    'hu',
    [
      'global',
      'hu'
    ]
  ],
  [
    'id-ID',
    [
      'global',
      'id',
      'id-ID'
    ]
  ],
  [
    'id',
    [
      'global',
      'id'
    ]
  ],
  [
    'it-CH',
    [
      'global',
      'it',
      'it-CH'
    ]
  ],
  [
    'it-IT',
    [
      'global',
      'it',
      'it-IT'
    ]
  ],
  [
    'it',
    [
      'global',
      'it'
    ]
  ],
  [
    'ka-GE',
    [
      'global',
      'ka',
      'ka-GE'
    ]
  ],
  [
    'ka',
    [
      'global',
      'ka'
    ]
  ],
  [
    'ko-KR',
    [
      'global',
      'ko',
      'ko-KR'
    ]
  ],
  [
    'ko',
    [
      'global',
      'ko'
    ]
  ],
  [
    'lt-LT',
    [
      'global',
      'lt',
      'lt-LT'
    ]
  ],
  [
    'lt',
    [
      'global',
      'lt'
    ]
  ],
  [
    'lv-LV',
    [
      'global',
      'lv',
      'lv-LV'
    ]
  ],
  [
    'lv',
    [
      'global',
      'lv'
    ]
  ],
  [
    'ms-BN',
    [
      'global',
      'ms',
      'ms-BN'
    ]
  ],
  [
    'ms-MY',
    [
      'global',
      'ms',
      'ms-MY'
    ]
  ],
  [
    'ms',
    [
      'global',
      'ms'
    ]
  ],
  [
    'nl-BE',
    [
      'global',
      'nl',
      'nl-BE'
    ]
  ],
  [
    'nl-NL',
    [
      'global',
      'nl',
      'nl-NL'
    ]
  ],
  [
    'nl',
    [
      'global',
      'nl'
    ]
  ],
  [
    'pl-PL',
    [
      'global',
      'pl',
      'pl-PL'
    ]
  ],
  [
    'pl',
    [
      'global',
      'pl'
    ]
  ],
  [
    'pt-PT',
    [
      'global',
      'pt',
      'pt-PT'
    ]
  ],
  [
    'pt',
    [
      'global',
      'pt'
    ]
  ],
  [
    'ro-MD',
    [
      'global',
      'ro',
      'ro-MD'
    ]
  ],
  [
    'ro-RO',
    [
      'global',
      'ro',
      'ro-RO'
    ]
  ],
  [
    'ro',
    [
      'global',
      'ro'
    ]
  ],
  [
    'ru-EE',
    [
      'global',
      'ru',
      'ru-EE'
    ]
  ],
  [
    'ru-LV',
    [
      'global',
      'ru',
      'ru-LV'
    ]
  ],
  [
    'ru',
    [
      'global',
      'ru'
    ]
  ],
  [
    'sk-SK',
    [
      'global',
      'sk',
      'sk-SK'
    ]
  ],
  [
    'sk',
    [
      'global',
      'sk'
    ]
  ],
  [
    'sl-SL',
    [
      'global',
      'sl',
      'sl-SL'
    ]
  ],
  [
    'sl',
    [
      'global',
      'sl'
    ]
  ],
  [
    'sr-RS',
    [
      'global',
      'sr',
      'sr-RS'
    ]
  ],
  [
    'sr',
    [
      'global',
      'sr'
    ]
  ],
  [
    'th-TH',
    [
      'global',
      'th',
      'th-TH'
    ]
  ],
  [
    'th',
    [
      'global',
      'th'
    ]
  ],
  [
    'tr-TR',
    [
      'global',
      'tr',
      'tr-TR'
    ]
  ],
  [
    'tr',
    [
      'global',
      'tr'
    ]
  ],
  [
    'vi-VN',
    [
      'global',
      'vi',
      'vi-VN'
    ]
  ],
  [
    'vi',
    [
      'global',
      'vi'
    ]
  ],
  [
    'xx-XX',
    [
      'global',
      'xx-XX'
    ]
  ],
  [
    'yy-XX',
    [
      'global',
      'yy-XX'
    ]
  ],
  [
    'yy-YY',
    [
      'global',
      'yy-YY'
    ]
  ],
  [
    'zh-HK',
    [
      'global',
      'zh',
      'zh-HK'
    ]
  ],
  [
    'zh',
    [
      'global',
      'zh'
    ]
  ],
  [
    'zu-ZA',
    [
      'global',
      'zu',
      'zu-ZA'
    ]
  ],
  [
    'zu',
    [
      'global',
      'zu'
    ]
  ]
]);
export const localesByRegion = new Map([
  [
    'AE',
    [
      'ar-AE',
      'en-AE'
    ]
  ],
  [
    'BH',
    [
      'ar-BH',
      'en-BH'
    ]
  ],
  [
    'EG',
    [
      'ar-EG',
      'en-EG'
    ]
  ],
  [
    'JO',
    [
      'ar-JO',
      'fr-JO'
    ]
  ],
  [
    'KW',
    [
      'ar-KW',
      'en-KW'
    ]
  ],
  [
    'LB',
    [
      'ar-LB',
      'en-LB',
      'fr-LB'
    ]
  ],
  [
    'MA',
    [
      'ar-MA',
      'fr-MA'
    ]
  ],
  [
    'OM',
    [
      'ar-OM',
      'en-OM'
    ]
  ],
  [
    'QA',
    [
      'ar-QA',
      'en-QA'
    ]
  ],
  [
    'SA',
    [
      'ar-SA',
      'en-SA'
    ]
  ],
  [
    'AZ',
    [
      'az-AZ'
    ]
  ],
  [
    'BG',
    [
      'bg-BG'
    ]
  ],
  [
    'ES',
    [
      'ca-ES',
      'en-ES',
      'es-ES'
    ]
  ],
  [
    'CZ',
    [
      'cs-CZ'
    ]
  ],
  [
    'DK',
    [
      'da-DK'
    ]
  ],
  [
    'AT',
    [
      'de-AT'
    ]
  ],
  [
    'BE',
    [
      'de-BE',
      'fr-BE',
      'nl-BE'
    ]
  ],
  [
    'CH',
    [
      'de-CH',
      'fr-CH',
      'it-CH'
    ]
  ],
  [
    'DE',
    [
      'de-DE'
    ]
  ],
  [
    'CY',
    [
      'el-CY'
    ]
  ],
  [
    'GR',
    [
      'el-GR'
    ]
  ],
  [
    'BN',
    [
      'en-BN',
      'ms-BN'
    ]
  ],
  [
    'CA',
    [
      'en-CA'
    ]
  ],
  [
    'LK',
    [
      'en-LK'
    ]
  ],
  [
    'MT',
    [
      'en-MT'
    ]
  ],
  [
    'MU',
    [
      'en-MU',
      'fr-MU'
    ]
  ],
  [
    'MY',
    [
      'en-MY',
      'ms-MY'
    ]
  ],
  [
    'NZ',
    [
      'en-NZ'
    ]
  ],
  [
    'PH',
    [
      'en-PH'
    ]
  ],
  [
    'PK',
    [
      'en-PK'
    ]
  ],
  [
    'SG',
    [
      'en-SG'
    ]
  ],
  [
    'UK',
    [
      'en-UK'
    ]
  ],
  [
    'US',
    [
      'en-US'
    ]
  ],
  [
    'ZA',
    [
      'en-ZA',
      'zu-ZA'
    ]
  ],
  [
    'CL',
    [
      'es-CL'
    ]
  ],
  [
    'VE',
    [
      'es-VE'
    ]
  ],
  [
    'EE',
    [
      'et-EE',
      'ru-EE'
    ]
  ],
  [
    'FI',
    [
      'fi-FI'
    ]
  ],
  [
    'HR',
    [
      'hr-HR'
    ]
  ],
  [
    'HU',
    [
      'hu-HU'
    ]
  ],
  [
    'ID',
    [
      'id-ID'
    ]
  ],
  [
    'IT',
    [
      'it-IT'
    ]
  ],
  [
    'GE',
    [
      'ka-GE'
    ]
  ],
  [
    'KR',
    [
      'ko-KR'
    ]
  ],
  [
    'LT',
    [
      'lt-LT'
    ]
  ],
  [
    'LV',
    [
      'lv-LV',
      'ru-LV'
    ]
  ],
  [
    'NL',
    [
      'nl-NL'
    ]
  ],
  [
    'PL',
    [
      'pl-PL'
    ]
  ],
  [
    'PT',
    [
      'pt-PT'
    ]
  ],
  [
    'MD',
    [
      'ro-MD'
    ]
  ],
  [
    'RO',
    [
      'ro-RO'
    ]
  ],
  [
    'SK',
    [
      'sk-SK'
    ]
  ],
  [
    'SL',
    [
      'sl-SL'
    ]
  ],
  [
    'RS',
    [
      'sr-RS'
    ]
  ],
  [
    'TH',
    [
      'th-TH'
    ]
  ],
  [
    'TR',
    [
      'tr-TR'
    ]
  ],
  [
    'VN',
    [
      'vi-VN'
    ]
  ],
  [
    'XX',
    [
      'xx-XX',
      'yy-XX'
    ]
  ],
  [
    'YY',
    [
      'yy-YY'
    ]
  ],
  [
    'HK',
    [
      'zh-HK'
    ]
  ]
]);
export const languageNames = new Map([
  [
    'de-AT',
    'Deutsch'
  ],
  [
    'de-BE',
    'Deutsch'
  ],
  [
    'de-CH',
    'Deutsch'
  ],
  [
    'de-DE',
    'Deutsch'
  ],
  [
    'el-CY',
    'Ελληνικά'
  ],
  [
    'el-GR',
    'Ελληνικά'
  ],
  [
    'en-AU',
    'English'
  ],
  [
    'en-BN',
    'English'
  ],
  [
    'en-CA',
    'English'
  ],
  [
    'en-ES',
    'English'
  ],
  [
    'en-FJ',
    'English'
  ],
  [
    'en-GB',
    'English'
  ],
  [
    'en-IE',
    'English'
  ],
  [
    'en-MT',
    'English'
  ],
  [
    'en-MY',
    'English'
  ],
  [
    'en-NZ',
    'English'
  ],
  [
    'en-PH',
    'English'
  ],
  [
    'en-SG',
    'English'
  ],
  [
    'en-UM',
    'English'
  ],
  [
    'en-US',
    'English'
  ],
  [
    'es-AR',
    'español'
  ],
  [
    'es-CL',
    'español'
  ],
  [
    'es-CO',
    'español'
  ],
  [
    'es-CR',
    'español'
  ],
  [
    'es-EC',
    'español'
  ],
  [
    'es-ES',
    'español'
  ],
  [
    'es-GT',
    'español'
  ],
  [
    'es-HN',
    'español'
  ],
  [
    'es-MX',
    'español'
  ],
  [
    'es-NI',
    'español'
  ],
  [
    'es-PE',
    'español'
  ],
  [
    'es-PY',
    'español'
  ],
  [
    'es-SV',
    'español'
  ],
  [
    'es-US',
    'español'
  ],
  [
    'es-UY',
    'español'
  ],
  [
    'es-VE',
    'español'
  ],
  [
    'et-EE',
    'eesti'
  ],
  [
    'fi-FI',
    'Suomalainen'
  ],
  [
    'fr-BE',
    'Français'
  ],
  [
    'fr-CH',
    'Français'
  ],
  [
    'fr-MA',
    'Français'
  ],
  [
    'he-IL',
    'עברית'
  ],
  [
    'hr-HR',
    'Hrvatski'
  ],
  [
    'hu-HU',
    'Magyar'
  ],
  [
    'id-ID',
    'Bahasa Indonesia'
  ],
  [
    'it-CH',
    'Italiano'
  ],
  [
    'it-IT',
    'Italiano'
  ],
  [
    'ka-GE',
    'ქართული'
  ],
  [
    'ko-KR',
    '한국인'
  ],
  [
    'lt-LT',
    'lietuvių'
  ],
  [
    'lv-LV',
    'latviešu'
  ],
  [
    'ms-BN',
    'Bahasa Melayu'
  ],
  [
    'ms-MY',
    'Bahasa Melayu'
  ],
  [
    'pl-PL',
    'Polski'
  ],
  [
    'pt-BR',
    'Português'
  ],
  [
    'pt-PT',
    'Português'
  ],
  [
    'ro-MD',
    'Română'
  ],
  [
    'ro-RO',
    'Română'
  ],
  [
    'ru-EE',
    'Русский'
  ],
  [
    'ru-LV',
    'Русский'
  ],
  [
    'sk-SK',
    'slovenský'
  ],
  [
    'sl-SI',
    'Slovenščina'
  ],
  [
    'sr-RS',
    'Српски'
  ],
  [
    'th-TH',
    'ไทย'
  ],
  [
    'uk-UA',
    'українська'
  ],
  [
    'vi-VN',
    'Tiếng Việt'
  ],
  [
    'ar-AE',
    'العربية'
  ],
  [
    'ar-BH',
    'العربية'
  ],
  [
    'ar-EG',
    'العربية'
  ],
  [
    'ar-IL',
    'العربية'
  ],
  [
    'ar-JO',
    'العربية'
  ],
  [
    'ar-KW',
    'العربية'
  ],
  [
    'ar-LB',
    'العربية'
  ],
  [
    'ar-MA',
    'العربية'
  ],
  [
    'ar-OM',
    'العربية'
  ],
  [
    'ar-QA',
    'العربية'
  ],
  [
    'ar-QT',
    'العربية'
  ],
  [
    'ar-SA',
    'العربية'
  ],
  [
    'az-AZ',
    'Azərbaycanca'
  ],
  [
    'bg-BG',
    'Български'
  ],
  [
    'ca-ES',
    'català'
  ],
  [
    'cs-CZ',
    'Čeština'
  ],
  [
    'en-AE',
    'English'
  ],
  [
    'en-BH',
    'English'
  ],
  [
    'en-EG',
    'English'
  ],
  [
    'en-KW',
    'English'
  ],
  [
    'en-LB',
    'English'
  ],
  [
    'en-LK',
    'English'
  ],
  [
    'en-MU',
    'English'
  ],
  [
    'en-OM',
    'English'
  ],
  [
    'en-QA',
    'English'
  ],
  [
    'en-QT',
    'English'
  ],
  [
    'en-SA',
    'English'
  ],
  [
    'en-ZA',
    'English'
  ],
  [
    'es-BE',
    'español'
  ],
  [
    'es-PA',
    'español'
  ],
  [
    'fr-JO',
    'Français'
  ],
  [
    'fr-LB',
    'Français'
  ],
  [
    'fr-MU',
    'Français'
  ],
  [
    'nl-BE',
    'Vlaams'
  ],
  [
    'nl-NL',
    'Nederlands'
  ],
  [
    'tr-TR',
    'Türkçe'
  ],
  [
    'zh-HK',
    '中文'
  ],
  [
    'zh-MO',
    '中文'
  ],
  [
    'zu-ZA',
    'Zulu'
  ]
]);
export const regionLocaleLangs = new Map([
  [
    'AE',
    {
      'region': 'AE',
      'locales': [
        'ar-AE',
        'en-AE'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'AE',
          'lang': 'ar',
          'targetLang': 'ar-ae',
          'locale': 'ar-AE',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'AE',
          'lang': 'en',
          'targetLang': 'en-ae',
          'locale': 'en-AE',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'BH',
    {
      'region': 'BH',
      'locales': [
        'ar-BH',
        'en-BH'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'BH',
          'lang': 'ar',
          'targetLang': 'ar-bh',
          'locale': 'ar-BH',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'BH',
          'lang': 'en',
          'targetLang': 'en-bh',
          'locale': 'en-BH',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'EG',
    {
      'region': 'EG',
      'locales': [
        'ar-EG',
        'en-EG'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'EG',
          'lang': 'ar',
          'targetLang': 'ar-eg',
          'locale': 'ar-EG',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'EG',
          'lang': 'en',
          'targetLang': 'en-eg',
          'locale': 'en-EG',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'JO',
    {
      'region': 'JO',
      'locales': [
        'ar-JO',
        'fr-JO'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'JO',
          'lang': 'ar',
          'targetLang': 'ar-jo',
          'locale': 'ar-JO',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'JO',
          'lang': 'fr',
          'targetLang': 'fr-jo',
          'locale': 'fr-JO',
          'dir': 'ltr',
          'displayName': 'Français'
        }
      ]
    }
  ],
  [
    'KW',
    {
      'region': 'KW',
      'locales': [
        'ar-KW',
        'en-KW'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'KW',
          'lang': 'ar',
          'targetLang': 'ar-kw',
          'locale': 'ar-KW',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'KW',
          'lang': 'en',
          'targetLang': 'en-kw',
          'locale': 'en-KW',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'LB',
    {
      'region': 'LB',
      'locales': [
        'ar-LB',
        'en-LB',
        'fr-LB'
      ],
      'langCount': 3,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'LB',
          'lang': 'ar',
          'targetLang': 'ar-lb',
          'locale': 'ar-LB',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'LB',
          'lang': 'en',
          'targetLang': 'en-lb',
          'locale': 'en-LB',
          'dir': 'ltr',
          'displayName': 'English'
        },
        {
          'region': 'LB',
          'lang': 'fr',
          'targetLang': 'fr-lb',
          'locale': 'fr-LB',
          'dir': 'ltr',
          'displayName': 'Français'
        }
      ]
    }
  ],
  [
    'MA',
    {
      'region': 'MA',
      'locales': [
        'ar-MA',
        'fr-MA'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'MA',
          'lang': 'ar',
          'targetLang': 'ar-ma',
          'locale': 'ar-MA',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'MA',
          'lang': 'fr',
          'targetLang': 'fr-ma',
          'locale': 'fr-MA',
          'dir': 'ltr',
          'displayName': 'Français'
        }
      ]
    }
  ],
  [
    'OM',
    {
      'region': 'OM',
      'locales': [
        'ar-OM',
        'en-OM'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'OM',
          'lang': 'ar',
          'targetLang': 'ar-om',
          'locale': 'ar-OM',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'OM',
          'lang': 'en',
          'targetLang': 'en-om',
          'locale': 'en-OM',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'QA',
    {
      'region': 'QA',
      'locales': [
        'ar-QA',
        'en-QA'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'QA',
          'lang': 'ar',
          'targetLang': 'ar-qa',
          'locale': 'ar-QA',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'QA',
          'lang': 'en',
          'targetLang': 'en-qa',
          'locale': 'en-QA',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'SA',
    {
      'region': 'SA',
      'locales': [
        'ar-SA',
        'en-SA'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'SA',
          'lang': 'ar',
          'targetLang': 'ar-sa',
          'locale': 'ar-SA',
          'dir': 'rtl',
          'displayName': 'العربية'
        },
        {
          'region': 'SA',
          'lang': 'en',
          'targetLang': 'en-sa',
          'locale': 'en-SA',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'AZ',
    {
      'region': 'AZ',
      'locales': [
        'az-AZ'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'AZ',
          'lang': 'az',
          'targetLang': 'az-az',
          'locale': 'az-AZ',
          'dir': 'ltr',
          'displayName': 'Azərbaycanca'
        }
      ]
    }
  ],
  [
    'BG',
    {
      'region': 'BG',
      'locales': [
        'bg-BG'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'BG',
          'lang': 'bg',
          'targetLang': 'bg-bg',
          'locale': 'bg-BG',
          'dir': 'ltr',
          'displayName': 'Български'
        }
      ]
    }
  ],
  [
    'ES',
    {
      'region': 'ES',
      'locales': [
        'ca-ES',
        'en-ES',
        'es-ES'
      ],
      'langCount': 3,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'ES',
          'lang': 'ca',
          'targetLang': 'ca-es',
          'locale': 'ca-ES',
          'dir': 'ltr',
          'displayName': 'català'
        },
        {
          'region': 'ES',
          'lang': 'en',
          'targetLang': 'en-es',
          'locale': 'en-ES',
          'dir': 'ltr',
          'displayName': 'English'
        },
        {
          'region': 'ES',
          'lang': 'es',
          'targetLang': 'es-es',
          'locale': 'es-ES',
          'dir': 'ltr',
          'displayName': 'español'
        }
      ]
    }
  ],
  [
    'CZ',
    {
      'region': 'CZ',
      'locales': [
        'cs-CZ'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'CZ',
          'lang': 'cs',
          'targetLang': 'cs-cz',
          'locale': 'cs-CZ',
          'dir': 'ltr',
          'displayName': 'Čeština'
        }
      ]
    }
  ],
  [
    'DK',
    {
      'region': 'DK',
      'locales': [
        'da-DK'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'DK',
          'lang': 'da',
          'targetLang': 'da-dk',
          'locale': 'da-DK',
          'dir': 'ltr',
          'displayName': 'da-DK (MISSING LANG NAME)'
        }
      ]
    }
  ],
  [
    'AT',
    {
      'region': 'AT',
      'locales': [
        'de-AT'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'AT',
          'lang': 'de',
          'targetLang': 'de-at',
          'locale': 'de-AT',
          'dir': 'ltr',
          'displayName': 'Deutsch'
        }
      ]
    }
  ],
  [
    'BE',
    {
      'region': 'BE',
      'locales': [
        'de-BE',
        'fr-BE',
        'nl-BE'
      ],
      'langCount': 3,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'BE',
          'lang': 'de',
          'targetLang': 'de-be',
          'locale': 'de-BE',
          'dir': 'ltr',
          'displayName': 'Deutsch'
        },
        {
          'region': 'BE',
          'lang': 'fr',
          'targetLang': 'fr-be',
          'locale': 'fr-BE',
          'dir': 'ltr',
          'displayName': 'Français'
        },
        {
          'region': 'BE',
          'lang': 'nl',
          'targetLang': 'nl-be',
          'locale': 'nl-BE',
          'dir': 'ltr',
          'displayName': 'Vlaams'
        }
      ]
    }
  ],
  [
    'CH',
    {
      'region': 'CH',
      'locales': [
        'de-CH',
        'fr-CH',
        'it-CH'
      ],
      'langCount': 3,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'CH',
          'lang': 'de',
          'targetLang': 'de-ch',
          'locale': 'de-CH',
          'dir': 'ltr',
          'displayName': 'Deutsch'
        },
        {
          'region': 'CH',
          'lang': 'fr',
          'targetLang': 'fr-ch',
          'locale': 'fr-CH',
          'dir': 'ltr',
          'displayName': 'Français'
        },
        {
          'region': 'CH',
          'lang': 'it',
          'targetLang': 'it-ch',
          'locale': 'it-CH',
          'dir': 'ltr',
          'displayName': 'Italiano'
        }
      ]
    }
  ],
  [
    'DE',
    {
      'region': 'DE',
      'locales': [
        'de-DE'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'DE',
          'lang': 'de',
          'targetLang': 'de-de',
          'locale': 'de-DE',
          'dir': 'ltr',
          'displayName': 'Deutsch'
        }
      ]
    }
  ],
  [
    'CY',
    {
      'region': 'CY',
      'locales': [
        'el-CY'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'CY',
          'lang': 'el',
          'targetLang': 'el-cy',
          'locale': 'el-CY',
          'dir': 'ltr',
          'displayName': 'Ελληνικά'
        }
      ]
    }
  ],
  [
    'GR',
    {
      'region': 'GR',
      'locales': [
        'el-GR'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'GR',
          'lang': 'el',
          'targetLang': 'el-gr',
          'locale': 'el-GR',
          'dir': 'ltr',
          'displayName': 'Ελληνικά'
        }
      ]
    }
  ],
  [
    'BN',
    {
      'region': 'BN',
      'locales': [
        'en-BN',
        'ms-BN'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'BN',
          'lang': 'en',
          'targetLang': 'en-bn',
          'locale': 'en-BN',
          'dir': 'ltr',
          'displayName': 'English'
        },
        {
          'region': 'BN',
          'lang': 'ms',
          'targetLang': 'ms-bn',
          'locale': 'ms-BN',
          'dir': 'ltr',
          'displayName': 'Bahasa Melayu'
        }
      ]
    }
  ],
  [
    'CA',
    {
      'region': 'CA',
      'locales': [
        'en-CA'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'CA',
          'lang': 'en',
          'targetLang': 'en-ca',
          'locale': 'en-CA',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'LK',
    {
      'region': 'LK',
      'locales': [
        'en-LK'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'LK',
          'lang': 'en',
          'targetLang': 'en-lk',
          'locale': 'en-LK',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'MT',
    {
      'region': 'MT',
      'locales': [
        'en-MT'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'MT',
          'lang': 'en',
          'targetLang': 'en-mt',
          'locale': 'en-MT',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'MU',
    {
      'region': 'MU',
      'locales': [
        'en-MU',
        'fr-MU'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'MU',
          'lang': 'en',
          'targetLang': 'en-mu',
          'locale': 'en-MU',
          'dir': 'ltr',
          'displayName': 'English'
        },
        {
          'region': 'MU',
          'lang': 'fr',
          'targetLang': 'fr-mu',
          'locale': 'fr-MU',
          'dir': 'ltr',
          'displayName': 'Français'
        }
      ]
    }
  ],
  [
    'MY',
    {
      'region': 'MY',
      'locales': [
        'en-MY',
        'ms-MY'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'MY',
          'lang': 'en',
          'targetLang': 'en-my',
          'locale': 'en-MY',
          'dir': 'ltr',
          'displayName': 'English'
        },
        {
          'region': 'MY',
          'lang': 'ms',
          'targetLang': 'ms-my',
          'locale': 'ms-MY',
          'dir': 'ltr',
          'displayName': 'Bahasa Melayu'
        }
      ]
    }
  ],
  [
    'NZ',
    {
      'region': 'NZ',
      'locales': [
        'en-NZ'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'NZ',
          'lang': 'en',
          'targetLang': 'en-nz',
          'locale': 'en-NZ',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'PH',
    {
      'region': 'PH',
      'locales': [
        'en-PH'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'PH',
          'lang': 'en',
          'targetLang': 'en-ph',
          'locale': 'en-PH',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'PK',
    {
      'region': 'PK',
      'locales': [
        'en-PK'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'PK',
          'lang': 'en',
          'targetLang': 'en-pk',
          'locale': 'en-PK',
          'dir': 'ltr',
          'displayName': 'en-PK (MISSING LANG NAME)'
        }
      ]
    }
  ],
  [
    'SG',
    {
      'region': 'SG',
      'locales': [
        'en-SG'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'SG',
          'lang': 'en',
          'targetLang': 'en-sg',
          'locale': 'en-SG',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'UK',
    {
      'region': 'UK',
      'locales': [
        'en-UK'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'GB',
          'lang': 'en',
          'targetLang': 'en-gb',
          'locale': 'en-UK',
          'dir': 'ltr',
          'displayName': 'en-UK (MISSING LANG NAME)'
        }
      ]
    }
  ],
  [
    'US',
    {
      'region': 'US',
      'locales': [
        'en-US'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'US',
          'lang': 'en',
          'targetLang': 'en-us',
          'locale': 'en-US',
          'dir': 'ltr',
          'displayName': 'English'
        }
      ]
    }
  ],
  [
    'ZA',
    {
      'region': 'ZA',
      'locales': [
        'en-ZA',
        'zu-ZA'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'ZA',
          'lang': 'en',
          'targetLang': 'en-za',
          'locale': 'en-ZA',
          'dir': 'ltr',
          'displayName': 'English'
        },
        {
          'region': 'ZA',
          'lang': 'zu',
          'targetLang': 'zu-za',
          'locale': 'zu-ZA',
          'dir': 'ltr',
          'displayName': 'Zulu'
        }
      ]
    }
  ],
  [
    'CL',
    {
      'region': 'CL',
      'locales': [
        'es-CL'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'CL',
          'lang': 'es',
          'targetLang': 'es-cl',
          'locale': 'es-CL',
          'dir': 'ltr',
          'displayName': 'español'
        }
      ]
    }
  ],
  [
    'VE',
    {
      'region': 'VE',
      'locales': [
        'es-VE'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'VE',
          'lang': 'es',
          'targetLang': 'es-ve',
          'locale': 'es-VE',
          'dir': 'ltr',
          'displayName': 'español'
        }
      ]
    }
  ],
  [
    'EE',
    {
      'region': 'EE',
      'locales': [
        'et-EE',
        'ru-EE'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'EE',
          'lang': 'et',
          'targetLang': 'et-ee',
          'locale': 'et-EE',
          'dir': 'ltr',
          'displayName': 'eesti'
        },
        {
          'region': 'EE',
          'lang': 'ru',
          'targetLang': 'ru-ee',
          'locale': 'ru-EE',
          'dir': 'ltr',
          'displayName': 'Русский'
        }
      ]
    }
  ],
  [
    'FI',
    {
      'region': 'FI',
      'locales': [
        'fi-FI'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'FI',
          'lang': 'fi',
          'targetLang': 'fi-fi',
          'locale': 'fi-FI',
          'dir': 'ltr',
          'displayName': 'Suomalainen'
        }
      ]
    }
  ],
  [
    'HR',
    {
      'region': 'HR',
      'locales': [
        'hr-HR'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'HR',
          'lang': 'hr',
          'targetLang': 'hr-hr',
          'locale': 'hr-HR',
          'dir': 'ltr',
          'displayName': 'Hrvatski'
        }
      ]
    }
  ],
  [
    'HU',
    {
      'region': 'HU',
      'locales': [
        'hu-HU'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'HU',
          'lang': 'hu',
          'targetLang': 'hu-hu',
          'locale': 'hu-HU',
          'dir': 'ltr',
          'displayName': 'Magyar'
        }
      ]
    }
  ],
  [
    'ID',
    {
      'region': 'ID',
      'locales': [
        'id-ID'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'ID',
          'lang': 'id',
          'targetLang': 'id-id',
          'locale': 'id-ID',
          'dir': 'ltr',
          'displayName': 'Bahasa Indonesia'
        }
      ]
    }
  ],
  [
    'IT',
    {
      'region': 'IT',
      'locales': [
        'it-IT'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'IT',
          'lang': 'it',
          'targetLang': 'it-it',
          'locale': 'it-IT',
          'dir': 'ltr',
          'displayName': 'Italiano'
        }
      ]
    }
  ],
  [
    'GE',
    {
      'region': 'GE',
      'locales': [
        'ka-GE'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'GE',
          'lang': 'ka',
          'targetLang': 'ka-ge',
          'locale': 'ka-GE',
          'dir': 'ltr',
          'displayName': 'ქართული'
        }
      ]
    }
  ],
  [
    'KR',
    {
      'region': 'KR',
      'locales': [
        'ko-KR'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'KR',
          'lang': 'ko',
          'targetLang': 'ko-kr',
          'locale': 'ko-KR',
          'dir': 'ltr',
          'displayName': '한국인'
        }
      ]
    }
  ],
  [
    'LT',
    {
      'region': 'LT',
      'locales': [
        'lt-LT'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'LT',
          'lang': 'lt',
          'targetLang': 'lt-lt',
          'locale': 'lt-LT',
          'dir': 'ltr',
          'displayName': 'lietuvių'
        }
      ]
    }
  ],
  [
    'LV',
    {
      'region': 'LV',
      'locales': [
        'lv-LV',
        'ru-LV'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'LV',
          'lang': 'lv',
          'targetLang': 'lv-lv',
          'locale': 'lv-LV',
          'dir': 'ltr',
          'displayName': 'latviešu'
        },
        {
          'region': 'LV',
          'lang': 'ru',
          'targetLang': 'ru-lv',
          'locale': 'ru-LV',
          'dir': 'ltr',
          'displayName': 'Русский'
        }
      ]
    }
  ],
  [
    'NL',
    {
      'region': 'NL',
      'locales': [
        'nl-NL'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'NL',
          'lang': 'nl',
          'targetLang': 'nl-nl',
          'locale': 'nl-NL',
          'dir': 'ltr',
          'displayName': 'Nederlands'
        }
      ]
    }
  ],
  [
    'PL',
    {
      'region': 'PL',
      'locales': [
        'pl-PL'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'PL',
          'lang': 'pl',
          'targetLang': 'pl-pl',
          'locale': 'pl-PL',
          'dir': 'ltr',
          'displayName': 'Polski'
        }
      ]
    }
  ],
  [
    'PT',
    {
      'region': 'PT',
      'locales': [
        'pt-PT'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'PT',
          'lang': 'pt',
          'targetLang': 'pt-pt',
          'locale': 'pt-PT',
          'dir': 'ltr',
          'displayName': 'Português'
        }
      ]
    }
  ],
  [
    'MD',
    {
      'region': 'MD',
      'locales': [
        'ro-MD'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'MD',
          'lang': 'ro',
          'targetLang': 'ro-md',
          'locale': 'ro-MD',
          'dir': 'ltr',
          'displayName': 'Română'
        }
      ]
    }
  ],
  [
    'RO',
    {
      'region': 'RO',
      'locales': [
        'ro-RO'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'RO',
          'lang': 'ro',
          'targetLang': 'ro-ro',
          'locale': 'ro-RO',
          'dir': 'ltr',
          'displayName': 'Română'
        }
      ]
    }
  ],
  [
    'SK',
    {
      'region': 'SK',
      'locales': [
        'sk-SK'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'SK',
          'lang': 'sk',
          'targetLang': 'sk-sk',
          'locale': 'sk-SK',
          'dir': 'ltr',
          'displayName': 'slovenský'
        }
      ]
    }
  ],
  [
    'SL',
    {
      'region': 'SL',
      'locales': [
        'sl-SL'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'SL',
          'lang': 'sl',
          'targetLang': 'sl-sl',
          'locale': 'sl-SL',
          'dir': 'ltr',
          'displayName': 'sl-SL (MISSING LANG NAME)'
        }
      ]
    }
  ],
  [
    'RS',
    {
      'region': 'RS',
      'locales': [
        'sr-RS'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'RS',
          'lang': 'sr',
          'targetLang': 'sr-rs',
          'locale': 'sr-RS',
          'dir': 'ltr',
          'displayName': 'Српски'
        }
      ]
    }
  ],
  [
    'TH',
    {
      'region': 'TH',
      'locales': [
        'th-TH'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'TH',
          'lang': 'th',
          'targetLang': 'th-th',
          'locale': 'th-TH',
          'dir': 'ltr',
          'displayName': 'ไทย'
        }
      ]
    }
  ],
  [
    'TR',
    {
      'region': 'TR',
      'locales': [
        'tr-TR'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'TR',
          'lang': 'tr',
          'targetLang': 'tr-tr',
          'locale': 'tr-TR',
          'dir': 'ltr',
          'displayName': 'Türkçe'
        }
      ]
    }
  ],
  [
    'VN',
    {
      'region': 'VN',
      'locales': [
        'vi-VN'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'VN',
          'lang': 'vi',
          'targetLang': 'vi-vn',
          'locale': 'vi-VN',
          'dir': 'ltr',
          'displayName': 'Tiếng Việt'
        }
      ]
    }
  ],
  [
    'XX',
    {
      'region': 'XX',
      'locales': [
        'xx-XX',
        'yy-XX'
      ],
      'langCount': 2,
      'showLangToggle': true,
      'languages': [
        {
          'region': 'XX',
          'lang': 'xx',
          'targetLang': 'xx-xx',
          'locale': 'xx-XX',
          'dir': 'ltr',
          'displayName': 'xx-XX (MISSING LANG NAME)'
        },
        {
          'region': 'XX',
          'lang': 'yy',
          'targetLang': 'yy-xx',
          'locale': 'yy-XX',
          'dir': 'ltr',
          'displayName': 'yy-XX (MISSING LANG NAME)'
        }
      ]
    }
  ],
  [
    'YY',
    {
      'region': 'YY',
      'locales': [
        'yy-YY'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'YY',
          'lang': 'yy',
          'targetLang': 'yy-yy',
          'locale': 'yy-YY',
          'dir': 'ltr',
          'displayName': 'yy-YY (MISSING LANG NAME)'
        }
      ]
    }
  ],
  [
    'HK',
    {
      'region': 'HK',
      'locales': [
        'zh-HK'
      ],
      'langCount': 1,
      'showLangToggle': false,
      'languages': [
        {
          'region': 'HK',
          'lang': 'zh',
          'targetLang': 'zh-hk',
          'locale': 'zh-HK',
          'dir': 'ltr',
          'displayName': '中文'
        }
      ]
    }
  ]
]);
export const localeLangs = new Map([
  [
    'ar-AE',
    [
      {
        'region': 'AE',
        'locales': [
          'ar-AE',
          'en-AE'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'AE',
            'lang': 'ar',
            'targetLang': 'ar-ae',
            'locale': 'ar-AE',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'AE',
            'lang': 'en',
            'targetLang': 'en-ae',
            'locale': 'en-AE',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'ar-BH',
    [
      {
        'region': 'BH',
        'locales': [
          'ar-BH',
          'en-BH'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BH',
            'lang': 'ar',
            'targetLang': 'ar-bh',
            'locale': 'ar-BH',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'BH',
            'lang': 'en',
            'targetLang': 'en-bh',
            'locale': 'en-BH',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'ar-EG',
    [
      {
        'region': 'EG',
        'locales': [
          'ar-EG',
          'en-EG'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'EG',
            'lang': 'ar',
            'targetLang': 'ar-eg',
            'locale': 'ar-EG',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'EG',
            'lang': 'en',
            'targetLang': 'en-eg',
            'locale': 'en-EG',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'ar-JO',
    [
      {
        'region': 'JO',
        'locales': [
          'ar-JO',
          'fr-JO'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'JO',
            'lang': 'ar',
            'targetLang': 'ar-jo',
            'locale': 'ar-JO',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'JO',
            'lang': 'fr',
            'targetLang': 'fr-jo',
            'locale': 'fr-JO',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'ar-KW',
    [
      {
        'region': 'KW',
        'locales': [
          'ar-KW',
          'en-KW'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'KW',
            'lang': 'ar',
            'targetLang': 'ar-kw',
            'locale': 'ar-KW',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'KW',
            'lang': 'en',
            'targetLang': 'en-kw',
            'locale': 'en-KW',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'ar-LB',
    [
      {
        'region': 'LB',
        'locales': [
          'ar-LB',
          'en-LB',
          'fr-LB'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'LB',
            'lang': 'ar',
            'targetLang': 'ar-lb',
            'locale': 'ar-LB',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'LB',
            'lang': 'en',
            'targetLang': 'en-lb',
            'locale': 'en-LB',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'LB',
            'lang': 'fr',
            'targetLang': 'fr-lb',
            'locale': 'fr-LB',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'ar-MA',
    [
      {
        'region': 'MA',
        'locales': [
          'ar-MA',
          'fr-MA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'MA',
            'lang': 'ar',
            'targetLang': 'ar-ma',
            'locale': 'ar-MA',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'MA',
            'lang': 'fr',
            'targetLang': 'fr-ma',
            'locale': 'fr-MA',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'ar-OM',
    [
      {
        'region': 'OM',
        'locales': [
          'ar-OM',
          'en-OM'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'OM',
            'lang': 'ar',
            'targetLang': 'ar-om',
            'locale': 'ar-OM',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'OM',
            'lang': 'en',
            'targetLang': 'en-om',
            'locale': 'en-OM',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'ar-QA',
    [
      {
        'region': 'QA',
        'locales': [
          'ar-QA',
          'en-QA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'QA',
            'lang': 'ar',
            'targetLang': 'ar-qa',
            'locale': 'ar-QA',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'QA',
            'lang': 'en',
            'targetLang': 'en-qa',
            'locale': 'en-QA',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'ar-SA',
    [
      {
        'region': 'SA',
        'locales': [
          'ar-SA',
          'en-SA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'SA',
            'lang': 'ar',
            'targetLang': 'ar-sa',
            'locale': 'ar-SA',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'SA',
            'lang': 'en',
            'targetLang': 'en-sa',
            'locale': 'en-SA',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'az-AZ',
    [
      {
        'region': 'AZ',
        'locales': [
          'az-AZ'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'AZ',
            'lang': 'az',
            'targetLang': 'az-az',
            'locale': 'az-AZ',
            'dir': 'ltr',
            'displayName': 'Azərbaycanca'
          }
        ]
      }
    ]
  ],
  [
    'bg-BG',
    [
      {
        'region': 'BG',
        'locales': [
          'bg-BG'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'BG',
            'lang': 'bg',
            'targetLang': 'bg-bg',
            'locale': 'bg-BG',
            'dir': 'ltr',
            'displayName': 'Български'
          }
        ]
      }
    ]
  ],
  [
    'ca-ES',
    [
      {
        'region': 'ES',
        'locales': [
          'ca-ES',
          'en-ES',
          'es-ES'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'ES',
            'lang': 'ca',
            'targetLang': 'ca-es',
            'locale': 'ca-ES',
            'dir': 'ltr',
            'displayName': 'català'
          },
          {
            'region': 'ES',
            'lang': 'en',
            'targetLang': 'en-es',
            'locale': 'en-ES',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'ES',
            'lang': 'es',
            'targetLang': 'es-es',
            'locale': 'es-ES',
            'dir': 'ltr',
            'displayName': 'español'
          }
        ]
      }
    ]
  ],
  [
    'cs-CZ',
    [
      {
        'region': 'CZ',
        'locales': [
          'cs-CZ'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'CZ',
            'lang': 'cs',
            'targetLang': 'cs-cz',
            'locale': 'cs-CZ',
            'dir': 'ltr',
            'displayName': 'Čeština'
          }
        ]
      }
    ]
  ],
  [
    'da-DK',
    [
      {
        'region': 'DK',
        'locales': [
          'da-DK'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'DK',
            'lang': 'da',
            'targetLang': 'da-dk',
            'locale': 'da-DK',
            'dir': 'ltr',
            'displayName': 'da-DK (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'de-AT',
    [
      {
        'region': 'AT',
        'locales': [
          'de-AT'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'AT',
            'lang': 'de',
            'targetLang': 'de-at',
            'locale': 'de-AT',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          }
        ]
      }
    ]
  ],
  [
    'de-BE',
    [
      {
        'region': 'BE',
        'locales': [
          'de-BE',
          'fr-BE',
          'nl-BE'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BE',
            'lang': 'de',
            'targetLang': 'de-be',
            'locale': 'de-BE',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          },
          {
            'region': 'BE',
            'lang': 'fr',
            'targetLang': 'fr-be',
            'locale': 'fr-BE',
            'dir': 'ltr',
            'displayName': 'Français'
          },
          {
            'region': 'BE',
            'lang': 'nl',
            'targetLang': 'nl-be',
            'locale': 'nl-BE',
            'dir': 'ltr',
            'displayName': 'Vlaams'
          }
        ]
      }
    ]
  ],
  [
    'de-CH',
    [
      {
        'region': 'CH',
        'locales': [
          'de-CH',
          'fr-CH',
          'it-CH'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'CH',
            'lang': 'de',
            'targetLang': 'de-ch',
            'locale': 'de-CH',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          },
          {
            'region': 'CH',
            'lang': 'fr',
            'targetLang': 'fr-ch',
            'locale': 'fr-CH',
            'dir': 'ltr',
            'displayName': 'Français'
          },
          {
            'region': 'CH',
            'lang': 'it',
            'targetLang': 'it-ch',
            'locale': 'it-CH',
            'dir': 'ltr',
            'displayName': 'Italiano'
          }
        ]
      }
    ]
  ],
  [
    'de-DE',
    [
      {
        'region': 'DE',
        'locales': [
          'de-DE'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'DE',
            'lang': 'de',
            'targetLang': 'de-de',
            'locale': 'de-DE',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          }
        ]
      }
    ]
  ],
  [
    'el-CY',
    [
      {
        'region': 'CY',
        'locales': [
          'el-CY'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'CY',
            'lang': 'el',
            'targetLang': 'el-cy',
            'locale': 'el-CY',
            'dir': 'ltr',
            'displayName': 'Ελληνικά'
          }
        ]
      }
    ]
  ],
  [
    'el-GR',
    [
      {
        'region': 'GR',
        'locales': [
          'el-GR'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'GR',
            'lang': 'el',
            'targetLang': 'el-gr',
            'locale': 'el-GR',
            'dir': 'ltr',
            'displayName': 'Ελληνικά'
          }
        ]
      }
    ]
  ],
  [
    'en-AE',
    [
      {
        'region': 'AE',
        'locales': [
          'ar-AE',
          'en-AE'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'AE',
            'lang': 'ar',
            'targetLang': 'ar-ae',
            'locale': 'ar-AE',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'AE',
            'lang': 'en',
            'targetLang': 'en-ae',
            'locale': 'en-AE',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-BH',
    [
      {
        'region': 'BH',
        'locales': [
          'ar-BH',
          'en-BH'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BH',
            'lang': 'ar',
            'targetLang': 'ar-bh',
            'locale': 'ar-BH',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'BH',
            'lang': 'en',
            'targetLang': 'en-bh',
            'locale': 'en-BH',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-BN',
    [
      {
        'region': 'BN',
        'locales': [
          'en-BN',
          'ms-BN'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BN',
            'lang': 'en',
            'targetLang': 'en-bn',
            'locale': 'en-BN',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'BN',
            'lang': 'ms',
            'targetLang': 'ms-bn',
            'locale': 'ms-BN',
            'dir': 'ltr',
            'displayName': 'Bahasa Melayu'
          }
        ]
      }
    ]
  ],
  [
    'en-CA',
    [
      {
        'region': 'CA',
        'locales': [
          'en-CA'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'CA',
            'lang': 'en',
            'targetLang': 'en-ca',
            'locale': 'en-CA',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-EG',
    [
      {
        'region': 'EG',
        'locales': [
          'ar-EG',
          'en-EG'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'EG',
            'lang': 'ar',
            'targetLang': 'ar-eg',
            'locale': 'ar-EG',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'EG',
            'lang': 'en',
            'targetLang': 'en-eg',
            'locale': 'en-EG',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-ES',
    [
      {
        'region': 'ES',
        'locales': [
          'ca-ES',
          'en-ES',
          'es-ES'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'ES',
            'lang': 'ca',
            'targetLang': 'ca-es',
            'locale': 'ca-ES',
            'dir': 'ltr',
            'displayName': 'català'
          },
          {
            'region': 'ES',
            'lang': 'en',
            'targetLang': 'en-es',
            'locale': 'en-ES',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'ES',
            'lang': 'es',
            'targetLang': 'es-es',
            'locale': 'es-ES',
            'dir': 'ltr',
            'displayName': 'español'
          }
        ]
      }
    ]
  ],
  [
    'en-KW',
    [
      {
        'region': 'KW',
        'locales': [
          'ar-KW',
          'en-KW'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'KW',
            'lang': 'ar',
            'targetLang': 'ar-kw',
            'locale': 'ar-KW',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'KW',
            'lang': 'en',
            'targetLang': 'en-kw',
            'locale': 'en-KW',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-LB',
    [
      {
        'region': 'LB',
        'locales': [
          'ar-LB',
          'en-LB',
          'fr-LB'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'LB',
            'lang': 'ar',
            'targetLang': 'ar-lb',
            'locale': 'ar-LB',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'LB',
            'lang': 'en',
            'targetLang': 'en-lb',
            'locale': 'en-LB',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'LB',
            'lang': 'fr',
            'targetLang': 'fr-lb',
            'locale': 'fr-LB',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'en-LK',
    [
      {
        'region': 'LK',
        'locales': [
          'en-LK'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'LK',
            'lang': 'en',
            'targetLang': 'en-lk',
            'locale': 'en-LK',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-MT',
    [
      {
        'region': 'MT',
        'locales': [
          'en-MT'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'MT',
            'lang': 'en',
            'targetLang': 'en-mt',
            'locale': 'en-MT',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-MU',
    [
      {
        'region': 'MU',
        'locales': [
          'en-MU',
          'fr-MU'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'MU',
            'lang': 'en',
            'targetLang': 'en-mu',
            'locale': 'en-MU',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'MU',
            'lang': 'fr',
            'targetLang': 'fr-mu',
            'locale': 'fr-MU',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'en-MY',
    [
      {
        'region': 'MY',
        'locales': [
          'en-MY',
          'ms-MY'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'MY',
            'lang': 'en',
            'targetLang': 'en-my',
            'locale': 'en-MY',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'MY',
            'lang': 'ms',
            'targetLang': 'ms-my',
            'locale': 'ms-MY',
            'dir': 'ltr',
            'displayName': 'Bahasa Melayu'
          }
        ]
      }
    ]
  ],
  [
    'en-NZ',
    [
      {
        'region': 'NZ',
        'locales': [
          'en-NZ'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'NZ',
            'lang': 'en',
            'targetLang': 'en-nz',
            'locale': 'en-NZ',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-OM',
    [
      {
        'region': 'OM',
        'locales': [
          'ar-OM',
          'en-OM'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'OM',
            'lang': 'ar',
            'targetLang': 'ar-om',
            'locale': 'ar-OM',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'OM',
            'lang': 'en',
            'targetLang': 'en-om',
            'locale': 'en-OM',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-PH',
    [
      {
        'region': 'PH',
        'locales': [
          'en-PH'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'PH',
            'lang': 'en',
            'targetLang': 'en-ph',
            'locale': 'en-PH',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-PK',
    [
      {
        'region': 'PK',
        'locales': [
          'en-PK'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'PK',
            'lang': 'en',
            'targetLang': 'en-pk',
            'locale': 'en-PK',
            'dir': 'ltr',
            'displayName': 'en-PK (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'en-QA',
    [
      {
        'region': 'QA',
        'locales': [
          'ar-QA',
          'en-QA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'QA',
            'lang': 'ar',
            'targetLang': 'ar-qa',
            'locale': 'ar-QA',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'QA',
            'lang': 'en',
            'targetLang': 'en-qa',
            'locale': 'en-QA',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-SA',
    [
      {
        'region': 'SA',
        'locales': [
          'ar-SA',
          'en-SA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'SA',
            'lang': 'ar',
            'targetLang': 'ar-sa',
            'locale': 'ar-SA',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'SA',
            'lang': 'en',
            'targetLang': 'en-sa',
            'locale': 'en-SA',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-SG',
    [
      {
        'region': 'SG',
        'locales': [
          'en-SG'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'SG',
            'lang': 'en',
            'targetLang': 'en-sg',
            'locale': 'en-SG',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-UK',
    [
      {
        'region': 'UK',
        'locales': [
          'en-UK'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'GB',
            'lang': 'en',
            'targetLang': 'en-gb',
            'locale': 'en-UK',
            'dir': 'ltr',
            'displayName': 'en-UK (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'en-US',
    [
      {
        'region': 'US',
        'locales': [
          'en-US'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'US',
            'lang': 'en',
            'targetLang': 'en-us',
            'locale': 'en-US',
            'dir': 'ltr',
            'displayName': 'English'
          }
        ]
      }
    ]
  ],
  [
    'en-ZA',
    [
      {
        'region': 'ZA',
        'locales': [
          'en-ZA',
          'zu-ZA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'ZA',
            'lang': 'en',
            'targetLang': 'en-za',
            'locale': 'en-ZA',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'ZA',
            'lang': 'zu',
            'targetLang': 'zu-za',
            'locale': 'zu-ZA',
            'dir': 'ltr',
            'displayName': 'Zulu'
          }
        ]
      }
    ]
  ],
  [
    'es-CL',
    [
      {
        'region': 'CL',
        'locales': [
          'es-CL'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'CL',
            'lang': 'es',
            'targetLang': 'es-cl',
            'locale': 'es-CL',
            'dir': 'ltr',
            'displayName': 'español'
          }
        ]
      }
    ]
  ],
  [
    'es-ES',
    [
      {
        'region': 'ES',
        'locales': [
          'ca-ES',
          'en-ES',
          'es-ES'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'ES',
            'lang': 'ca',
            'targetLang': 'ca-es',
            'locale': 'ca-ES',
            'dir': 'ltr',
            'displayName': 'català'
          },
          {
            'region': 'ES',
            'lang': 'en',
            'targetLang': 'en-es',
            'locale': 'en-ES',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'ES',
            'lang': 'es',
            'targetLang': 'es-es',
            'locale': 'es-ES',
            'dir': 'ltr',
            'displayName': 'español'
          }
        ]
      }
    ]
  ],
  [
    'es-VE',
    [
      {
        'region': 'VE',
        'locales': [
          'es-VE'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'VE',
            'lang': 'es',
            'targetLang': 'es-ve',
            'locale': 'es-VE',
            'dir': 'ltr',
            'displayName': 'español'
          }
        ]
      }
    ]
  ],
  [
    'et-EE',
    [
      {
        'region': 'EE',
        'locales': [
          'et-EE',
          'ru-EE'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'EE',
            'lang': 'et',
            'targetLang': 'et-ee',
            'locale': 'et-EE',
            'dir': 'ltr',
            'displayName': 'eesti'
          },
          {
            'region': 'EE',
            'lang': 'ru',
            'targetLang': 'ru-ee',
            'locale': 'ru-EE',
            'dir': 'ltr',
            'displayName': 'Русский'
          }
        ]
      }
    ]
  ],
  [
    'fi-FI',
    [
      {
        'region': 'FI',
        'locales': [
          'fi-FI'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'FI',
            'lang': 'fi',
            'targetLang': 'fi-fi',
            'locale': 'fi-FI',
            'dir': 'ltr',
            'displayName': 'Suomalainen'
          }
        ]
      }
    ]
  ],
  [
    'fr-BE',
    [
      {
        'region': 'BE',
        'locales': [
          'de-BE',
          'fr-BE',
          'nl-BE'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BE',
            'lang': 'de',
            'targetLang': 'de-be',
            'locale': 'de-BE',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          },
          {
            'region': 'BE',
            'lang': 'fr',
            'targetLang': 'fr-be',
            'locale': 'fr-BE',
            'dir': 'ltr',
            'displayName': 'Français'
          },
          {
            'region': 'BE',
            'lang': 'nl',
            'targetLang': 'nl-be',
            'locale': 'nl-BE',
            'dir': 'ltr',
            'displayName': 'Vlaams'
          }
        ]
      }
    ]
  ],
  [
    'fr-CH',
    [
      {
        'region': 'CH',
        'locales': [
          'de-CH',
          'fr-CH',
          'it-CH'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'CH',
            'lang': 'de',
            'targetLang': 'de-ch',
            'locale': 'de-CH',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          },
          {
            'region': 'CH',
            'lang': 'fr',
            'targetLang': 'fr-ch',
            'locale': 'fr-CH',
            'dir': 'ltr',
            'displayName': 'Français'
          },
          {
            'region': 'CH',
            'lang': 'it',
            'targetLang': 'it-ch',
            'locale': 'it-CH',
            'dir': 'ltr',
            'displayName': 'Italiano'
          }
        ]
      }
    ]
  ],
  [
    'fr-JO',
    [
      {
        'region': 'JO',
        'locales': [
          'ar-JO',
          'fr-JO'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'JO',
            'lang': 'ar',
            'targetLang': 'ar-jo',
            'locale': 'ar-JO',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'JO',
            'lang': 'fr',
            'targetLang': 'fr-jo',
            'locale': 'fr-JO',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'fr-LB',
    [
      {
        'region': 'LB',
        'locales': [
          'ar-LB',
          'en-LB',
          'fr-LB'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'LB',
            'lang': 'ar',
            'targetLang': 'ar-lb',
            'locale': 'ar-LB',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'LB',
            'lang': 'en',
            'targetLang': 'en-lb',
            'locale': 'en-LB',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'LB',
            'lang': 'fr',
            'targetLang': 'fr-lb',
            'locale': 'fr-LB',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'fr-MA',
    [
      {
        'region': 'MA',
        'locales': [
          'ar-MA',
          'fr-MA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'MA',
            'lang': 'ar',
            'targetLang': 'ar-ma',
            'locale': 'ar-MA',
            'dir': 'rtl',
            'displayName': 'العربية'
          },
          {
            'region': 'MA',
            'lang': 'fr',
            'targetLang': 'fr-ma',
            'locale': 'fr-MA',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'fr-MU',
    [
      {
        'region': 'MU',
        'locales': [
          'en-MU',
          'fr-MU'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'MU',
            'lang': 'en',
            'targetLang': 'en-mu',
            'locale': 'en-MU',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'MU',
            'lang': 'fr',
            'targetLang': 'fr-mu',
            'locale': 'fr-MU',
            'dir': 'ltr',
            'displayName': 'Français'
          }
        ]
      }
    ]
  ],
  [
    'hr-HR',
    [
      {
        'region': 'HR',
        'locales': [
          'hr-HR'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'HR',
            'lang': 'hr',
            'targetLang': 'hr-hr',
            'locale': 'hr-HR',
            'dir': 'ltr',
            'displayName': 'Hrvatski'
          }
        ]
      }
    ]
  ],
  [
    'hu-HU',
    [
      {
        'region': 'HU',
        'locales': [
          'hu-HU'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'HU',
            'lang': 'hu',
            'targetLang': 'hu-hu',
            'locale': 'hu-HU',
            'dir': 'ltr',
            'displayName': 'Magyar'
          }
        ]
      }
    ]
  ],
  [
    'id-ID',
    [
      {
        'region': 'ID',
        'locales': [
          'id-ID'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'ID',
            'lang': 'id',
            'targetLang': 'id-id',
            'locale': 'id-ID',
            'dir': 'ltr',
            'displayName': 'Bahasa Indonesia'
          }
        ]
      }
    ]
  ],
  [
    'it-CH',
    [
      {
        'region': 'CH',
        'locales': [
          'de-CH',
          'fr-CH',
          'it-CH'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'CH',
            'lang': 'de',
            'targetLang': 'de-ch',
            'locale': 'de-CH',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          },
          {
            'region': 'CH',
            'lang': 'fr',
            'targetLang': 'fr-ch',
            'locale': 'fr-CH',
            'dir': 'ltr',
            'displayName': 'Français'
          },
          {
            'region': 'CH',
            'lang': 'it',
            'targetLang': 'it-ch',
            'locale': 'it-CH',
            'dir': 'ltr',
            'displayName': 'Italiano'
          }
        ]
      }
    ]
  ],
  [
    'it-IT',
    [
      {
        'region': 'IT',
        'locales': [
          'it-IT'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'IT',
            'lang': 'it',
            'targetLang': 'it-it',
            'locale': 'it-IT',
            'dir': 'ltr',
            'displayName': 'Italiano'
          }
        ]
      }
    ]
  ],
  [
    'ka-GE',
    [
      {
        'region': 'GE',
        'locales': [
          'ka-GE'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'GE',
            'lang': 'ka',
            'targetLang': 'ka-ge',
            'locale': 'ka-GE',
            'dir': 'ltr',
            'displayName': 'ქართული'
          }
        ]
      }
    ]
  ],
  [
    'ko-KR',
    [
      {
        'region': 'KR',
        'locales': [
          'ko-KR'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'KR',
            'lang': 'ko',
            'targetLang': 'ko-kr',
            'locale': 'ko-KR',
            'dir': 'ltr',
            'displayName': '한국인'
          }
        ]
      }
    ]
  ],
  [
    'lt-LT',
    [
      {
        'region': 'LT',
        'locales': [
          'lt-LT'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'LT',
            'lang': 'lt',
            'targetLang': 'lt-lt',
            'locale': 'lt-LT',
            'dir': 'ltr',
            'displayName': 'lietuvių'
          }
        ]
      }
    ]
  ],
  [
    'lv-LV',
    [
      {
        'region': 'LV',
        'locales': [
          'lv-LV',
          'ru-LV'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'LV',
            'lang': 'lv',
            'targetLang': 'lv-lv',
            'locale': 'lv-LV',
            'dir': 'ltr',
            'displayName': 'latviešu'
          },
          {
            'region': 'LV',
            'lang': 'ru',
            'targetLang': 'ru-lv',
            'locale': 'ru-LV',
            'dir': 'ltr',
            'displayName': 'Русский'
          }
        ]
      }
    ]
  ],
  [
    'ms-BN',
    [
      {
        'region': 'BN',
        'locales': [
          'en-BN',
          'ms-BN'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BN',
            'lang': 'en',
            'targetLang': 'en-bn',
            'locale': 'en-BN',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'BN',
            'lang': 'ms',
            'targetLang': 'ms-bn',
            'locale': 'ms-BN',
            'dir': 'ltr',
            'displayName': 'Bahasa Melayu'
          }
        ]
      }
    ]
  ],
  [
    'ms-MY',
    [
      {
        'region': 'MY',
        'locales': [
          'en-MY',
          'ms-MY'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'MY',
            'lang': 'en',
            'targetLang': 'en-my',
            'locale': 'en-MY',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'MY',
            'lang': 'ms',
            'targetLang': 'ms-my',
            'locale': 'ms-MY',
            'dir': 'ltr',
            'displayName': 'Bahasa Melayu'
          }
        ]
      }
    ]
  ],
  [
    'nl-BE',
    [
      {
        'region': 'BE',
        'locales': [
          'de-BE',
          'fr-BE',
          'nl-BE'
        ],
        'langCount': 3,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'BE',
            'lang': 'de',
            'targetLang': 'de-be',
            'locale': 'de-BE',
            'dir': 'ltr',
            'displayName': 'Deutsch'
          },
          {
            'region': 'BE',
            'lang': 'fr',
            'targetLang': 'fr-be',
            'locale': 'fr-BE',
            'dir': 'ltr',
            'displayName': 'Français'
          },
          {
            'region': 'BE',
            'lang': 'nl',
            'targetLang': 'nl-be',
            'locale': 'nl-BE',
            'dir': 'ltr',
            'displayName': 'Vlaams'
          }
        ]
      }
    ]
  ],
  [
    'nl-NL',
    [
      {
        'region': 'NL',
        'locales': [
          'nl-NL'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'NL',
            'lang': 'nl',
            'targetLang': 'nl-nl',
            'locale': 'nl-NL',
            'dir': 'ltr',
            'displayName': 'Nederlands'
          }
        ]
      }
    ]
  ],
  [
    'pl-PL',
    [
      {
        'region': 'PL',
        'locales': [
          'pl-PL'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'PL',
            'lang': 'pl',
            'targetLang': 'pl-pl',
            'locale': 'pl-PL',
            'dir': 'ltr',
            'displayName': 'Polski'
          }
        ]
      }
    ]
  ],
  [
    'pt-PT',
    [
      {
        'region': 'PT',
        'locales': [
          'pt-PT'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'PT',
            'lang': 'pt',
            'targetLang': 'pt-pt',
            'locale': 'pt-PT',
            'dir': 'ltr',
            'displayName': 'Português'
          }
        ]
      }
    ]
  ],
  [
    'ro-MD',
    [
      {
        'region': 'MD',
        'locales': [
          'ro-MD'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'MD',
            'lang': 'ro',
            'targetLang': 'ro-md',
            'locale': 'ro-MD',
            'dir': 'ltr',
            'displayName': 'Română'
          }
        ]
      }
    ]
  ],
  [
    'ro-RO',
    [
      {
        'region': 'RO',
        'locales': [
          'ro-RO'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'RO',
            'lang': 'ro',
            'targetLang': 'ro-ro',
            'locale': 'ro-RO',
            'dir': 'ltr',
            'displayName': 'Română'
          }
        ]
      }
    ]
  ],
  [
    'ru-EE',
    [
      {
        'region': 'EE',
        'locales': [
          'et-EE',
          'ru-EE'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'EE',
            'lang': 'et',
            'targetLang': 'et-ee',
            'locale': 'et-EE',
            'dir': 'ltr',
            'displayName': 'eesti'
          },
          {
            'region': 'EE',
            'lang': 'ru',
            'targetLang': 'ru-ee',
            'locale': 'ru-EE',
            'dir': 'ltr',
            'displayName': 'Русский'
          }
        ]
      }
    ]
  ],
  [
    'ru-LV',
    [
      {
        'region': 'LV',
        'locales': [
          'lv-LV',
          'ru-LV'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'LV',
            'lang': 'lv',
            'targetLang': 'lv-lv',
            'locale': 'lv-LV',
            'dir': 'ltr',
            'displayName': 'latviešu'
          },
          {
            'region': 'LV',
            'lang': 'ru',
            'targetLang': 'ru-lv',
            'locale': 'ru-LV',
            'dir': 'ltr',
            'displayName': 'Русский'
          }
        ]
      }
    ]
  ],
  [
    'sk-SK',
    [
      {
        'region': 'SK',
        'locales': [
          'sk-SK'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'SK',
            'lang': 'sk',
            'targetLang': 'sk-sk',
            'locale': 'sk-SK',
            'dir': 'ltr',
            'displayName': 'slovenský'
          }
        ]
      }
    ]
  ],
  [
    'sl-SL',
    [
      {
        'region': 'SL',
        'locales': [
          'sl-SL'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'SL',
            'lang': 'sl',
            'targetLang': 'sl-sl',
            'locale': 'sl-SL',
            'dir': 'ltr',
            'displayName': 'sl-SL (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'sr-RS',
    [
      {
        'region': 'RS',
        'locales': [
          'sr-RS'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'RS',
            'lang': 'sr',
            'targetLang': 'sr-rs',
            'locale': 'sr-RS',
            'dir': 'ltr',
            'displayName': 'Српски'
          }
        ]
      }
    ]
  ],
  [
    'th-TH',
    [
      {
        'region': 'TH',
        'locales': [
          'th-TH'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'TH',
            'lang': 'th',
            'targetLang': 'th-th',
            'locale': 'th-TH',
            'dir': 'ltr',
            'displayName': 'ไทย'
          }
        ]
      }
    ]
  ],
  [
    'tr-TR',
    [
      {
        'region': 'TR',
        'locales': [
          'tr-TR'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'TR',
            'lang': 'tr',
            'targetLang': 'tr-tr',
            'locale': 'tr-TR',
            'dir': 'ltr',
            'displayName': 'Türkçe'
          }
        ]
      }
    ]
  ],
  [
    'vi-VN',
    [
      {
        'region': 'VN',
        'locales': [
          'vi-VN'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'VN',
            'lang': 'vi',
            'targetLang': 'vi-vn',
            'locale': 'vi-VN',
            'dir': 'ltr',
            'displayName': 'Tiếng Việt'
          }
        ]
      }
    ]
  ],
  [
    'xx-XX',
    [
      {
        'region': 'XX',
        'locales': [
          'xx-XX',
          'yy-XX'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'XX',
            'lang': 'xx',
            'targetLang': 'xx-xx',
            'locale': 'xx-XX',
            'dir': 'ltr',
            'displayName': 'xx-XX (MISSING LANG NAME)'
          },
          {
            'region': 'XX',
            'lang': 'yy',
            'targetLang': 'yy-xx',
            'locale': 'yy-XX',
            'dir': 'ltr',
            'displayName': 'yy-XX (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'yy-XX',
    [
      {
        'region': 'XX',
        'locales': [
          'xx-XX',
          'yy-XX'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'XX',
            'lang': 'xx',
            'targetLang': 'xx-xx',
            'locale': 'xx-XX',
            'dir': 'ltr',
            'displayName': 'xx-XX (MISSING LANG NAME)'
          },
          {
            'region': 'XX',
            'lang': 'yy',
            'targetLang': 'yy-xx',
            'locale': 'yy-XX',
            'dir': 'ltr',
            'displayName': 'yy-XX (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'yy-YY',
    [
      {
        'region': 'YY',
        'locales': [
          'yy-YY'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'YY',
            'lang': 'yy',
            'targetLang': 'yy-yy',
            'locale': 'yy-YY',
            'dir': 'ltr',
            'displayName': 'yy-YY (MISSING LANG NAME)'
          }
        ]
      }
    ]
  ],
  [
    'zh-HK',
    [
      {
        'region': 'HK',
        'locales': [
          'zh-HK'
        ],
        'langCount': 1,
        'showLangToggle': false,
        'languages': [
          {
            'region': 'HK',
            'lang': 'zh',
            'targetLang': 'zh-hk',
            'locale': 'zh-HK',
            'dir': 'ltr',
            'displayName': '中文'
          }
        ]
      }
    ]
  ],
  [
    'zu-ZA',
    [
      {
        'region': 'ZA',
        'locales': [
          'en-ZA',
          'zu-ZA'
        ],
        'langCount': 2,
        'showLangToggle': true,
        'languages': [
          {
            'region': 'ZA',
            'lang': 'en',
            'targetLang': 'en-za',
            'locale': 'en-ZA',
            'dir': 'ltr',
            'displayName': 'English'
          },
          {
            'region': 'ZA',
            'lang': 'zu',
            'targetLang': 'zu-za',
            'locale': 'zu-ZA',
            'dir': 'ltr',
            'displayName': 'Zulu'
          }
        ]
      }
    ]
  ]
]);
